import Model from '../model';
import * as systemActions from './actions';
import {history, store} from '/app/src/store/store'
import SystemSelector from './selector'


class System extends Model {
    constructor(){
        super();
        // TOOGLE MENU OFF WHEN WE CHANGE ROUTE
        this.selector = SystemSelector
        // TOOGLE MENU OFF WHEN WE CHANGE ROUTE (DOES NOT TOOGLE WHEN
        // PATHNAME IS '/' WHICH MEANS USER IS AT THE LOGIN SCREEN)
        history.listen(location => {
            let toogle = store.getState().getIn(['system', 'menu', 'toogle'], true)
            if(toogle && location.pathname !== '/'){
                store.dispatch((systemActions.menuToogle(false)));
            }
        })
    }
    openModal(route, data){
        return (dispatch) => {
            dispatch(systemActions.openModal(route, data));
        }
    }

    closeModal(){
        return (dispatch) => {
            dispatch(systemActions.closeModal());
        }
    }
    menuToogle(toogle){
        return (dispatch) => {
            dispatch(systemActions.menuToogle(toogle));
        }
    }
    navigateTo(to){
        return (dispatch) => {
            history.push(to)
        }
    }

    toogleRightMenu(){
        const selectorFunction = (state) => {
            return {
                'toogle': this.selector.getMenuToogle(state),
            }
        }
        const dispatchFunction = (toogle) => {
            return (dispatch) => {
                dispatch(systemActions.menuToogle(toogle));
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }
}

export default new System();



// WEBPACK FOOTER //
// ./src/model/System/model.js